export const SOLIDJS_NODEJS_IMPORT_YAML = `project:
  name: recipe-solidjs
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: nodejs@20
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-solidjs-nodejs`;
